import * as React from 'react';

import styles from './list-summaries-empty.module.css';

export class ListSummariesEmpty extends React.Component {
    render() {
        return (
            <div className={styles.container}>
                <p>No saved list selected</p>
                <span>Choose at least one saved list.</span>
            </div>
        );
    }
}
